import { isProd } from "@/config/common";
import {
  ContentfulLocaleEnum,
  CountryCodeEnum,
  CountryNameEnum,
  CurrencyCodeEnum,
  DomainEnum,
  ElevateCodeEnum,
  LanguageCodeEnum,
  type Market,
  PSPEnum,
  SiteLocaleEnum,
  SiteNameEnum,
} from "./i18n-config";

export const es: Market = {
  psp: PSPEnum.ADYEN,
  flag: "🇪🇸",
  currency: CurrencyCodeEnum.EUR,
  countryCode: CountryCodeEnum.ES,
  countryName: CountryNameEnum.ES,
  languageCode: LanguageCodeEnum.EN,
  locale: `${LanguageCodeEnum.EN}-${CountryCodeEnum.ES}`,
  upperCaseLocale: `${LanguageCodeEnum.EN}-${CountryCodeEnum.ES.toUpperCase()}`,
  contentfulLocale: ContentfulLocaleEnum.EU,
  siteLocale: SiteLocaleEnum.ES,
  elevateMarket: ElevateCodeEnum.EU,
  externalStoreId: "ecom-noga",
  searchPathName: "/search",
  domain: DomainEnum.NOGA,
  imageCdn: isProd()
    ? "https://cdn.no-ga.com"
    : "https://media.stage.cdn-norce.tech/1413",
  siteName: SiteNameEnum.EU,
};
